<template>
  <section>
    <el-collapse v-model="outboundUnits.filtersOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="outbound-units-search-section"
        id="outbound-units-search-section"
      >
        <el-form
          id="outbound-units-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.dayOfServiceFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.dayOfServiceFrom"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-dayOfServiceFrom"
                  ref="filter-dayOfServiceFrom"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.dayOfServiceTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.dayOfServiceTo"
                  format="MM/dd/yyyy"
                  clearable
                  type="date"
                  id="searchForm-dayOfServiceTo"
                  ref="filter-dayOfServiceTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.outboundWarehouse')">
                <outbound-warehouse-select v-model="searchForm.outboundWarehouseId" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.outboundDateFrom')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.outboundDateFrom"
                  format="MM/dd/yyyy"
                  type="date"
                  id="searchForm-outboundDateFrom"
                  ref="filter-outboundDateFrom"
                  clearable
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('customerService.shipment.outboundDateTo')">
                <el-date-picker
                  class="el-dropdown-new drop-sp date-dob"
                  v-model="searchForm.outboundDateTo"
                  format="MM/dd/yyyy"
                  type="date"
                  clearable
                  id="searchForm-outboundDateTo"
                  ref="filter-outboundDateTo"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.receivingWarehouse')">
                <outbound-warehouse-select v-model="searchForm.warehouseId" :includeOptionAll="true" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.status')">
                <el-select
                  v-model="filterStatus"
                  id="searchForm-status"
                  ref="filter-status"
                >
                  <el-option
                    v-for="option in unitStatusOptions"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.orderNumber')">
                <el-input
                  v-model="searchForm.orderNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-orderNumber"
                  id="searchForm-orderNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.shipper')">
                <autocomplete
                  :model.sync="searchForm.shipperAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlShippers"
                  labelField="name"
                  valueField="id"
                  ref="filter-shipperAccountId"
                  id="searchForm-shipperAccountId"
                />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.consignee')">
                <autocomplete
                  :model.sync="searchForm.consigneeAccountId"
                  :shipperAccountId="null"
                  labelFieldLastWithDash="number"
                  popperAppendToBody
                  :url="urlConsignee"
                  labelField="name"
                  valueField="id"
                  ref="filter-consigneeAccountId"
                  id="searchForm-consigneeAccountId"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.consolidateId')">
                <el-input
                  v-model="searchForm.unitsConsolidateId"
                  v-numeric-validation
                  maxlength="20"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-consolidateId"
                  id="searchForm-consolidateId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.unitID')">
                <el-input
                  v-model="searchForm.unitId"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-unitId"
                  id="searchForm-unitId"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.receivingPallet')">
                <el-input
                  v-model="searchForm.receivingPalletCode"
                  v-alphanumeric-validation
                  maxlength="6"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-receivingPalletCode"
                  id="searchForm-receivingPalletCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.putAwayID')">
                <el-input
                  v-model="searchForm.putAwayCode"
                  v-alphanumeric-validation
                  maxlength="10"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-putAwayCode"
                  id="searchForm-putAwayCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.shuttle')">
                <el-input
                  v-model="searchForm.shuttleNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-shuttleNumber"
                  id="searchForm-shuttleNumber"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.loadNumber')">
                <el-input
                  v-model="searchForm.loadNumber"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-loadNumber"
                  id="searchForm-loadNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('outbound.units.trailer')">
                <el-input
                  v-model="searchForm.trailer"
                  v-alphanumeric-validation
                  maxlength="20"
                  clearable
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                  ref="filter-trailer"
                  id="searchForm-trailer"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="text-align-end">
              <el-tooltip
                  :content="$t('common.search')"
                  class="item"
                  effect="dark"
                  placement="top-start"
              >
                <el-button
                    id="outbound-units-search-section-form-button"
                    class="button-action-default"
                    @click="handleSearch"
                    icon="el-icon-search"
                    size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
import { Message } from 'element-ui';
import Autocomplete from '@/components/Autocomplete';
import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import { OUTBOUND_UNITS_SEARCH } from '@/store/actions';

export default {
  name: 'OutboundUnitsSearchSection',
  components: { Autocomplete, OutboundWarehouseSelect },
  computed: {
    ...mapGetters(['outboundUnits']),
    deletedOptions() {
      /* Inverted value intended
       * Deleted: true -> Active: false
       * Deleted: false -> Active: true
      */
      return [
        {
          value: constants.STATUS_BOOLEAN.yes.value,
          label: constants.STATUS_BOOLEAN.no.label
        },
        {
          value: constants.STATUS_BOOLEAN.no.value,
          label: constants.STATUS_BOOLEAN.yes.label
        }
      ];
    },
    unitReceivedStatus() {
      return constants.UNIT.STATUS[2];
    },
    unitArrivedStatus() {
      return constants.UNIT.STATUS[8];
    },
    unitStatusOptions() {
      return constants.UNIT.STATUS;
    },
    urlConsignee() {
      return apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE;
    },
    urlShippers() {
      return apiConstants.END_POINTS.ACCOUNTS.SHIPPERS;
    },
  },
  data() {
    return {
      activeCollapsibleName: ['outbound-units-search-section'],
      isOpen: ['outbound-units-search-section'],
      searchForm: {
        outboundDateFrom: null,
        outboundDateTo: null,
        dayOfServiceFrom: new Date(),
        dayOfServiceTo: null,
        status: null,
        warehouseId: null,
        outboundWarehouseId: null,
        shipperAccountId: null,
        consigneeAccountId: null,
        receivingPalletCode: '',
        putAwayCode: '',
        unitId: '',
        unitsConsolidateId: null,
        orderNumber: '',
        trailer: '',
        loadNumber: '',
        shuttleNumber: '',
        checkForArrivedShuttle: false,
        page: constants.TABLES.DEFAULT_PAGE,
      },
      filterStatus: constants.UNIT.STATUS[0].value,
    };
  },
  watch: {
    'searchForm.dayOfServiceFrom': function updateTo(newVal) {
      // to work with changes in someOtherProp
      const newDayOfServiceFrom = moment(newVal);
      if (newDayOfServiceFrom.isAfter(moment(this.searchForm.dayOfServiceTo))) {
        this.searchForm.dayOfServiceTo = newVal;
      }
    },
    'searchForm.dayOfServiceTo': function updateFrom(newVal) {
      const newDayOfServiceTo = moment(newVal);
      if (newDayOfServiceTo.isBefore(moment(this.searchForm.dayOfServiceFrom))) {
        this.searchForm.dayOfServiceFrom = newVal;
      }
    }
  },
  methods: {
    ...mapActions({
      search: OUTBOUND_UNITS_SEARCH,
    }),
    handleSearch() {
      if (!this.validateSearch()) return;

      this.searchForm.status = this.filterStatus;
      this.searchForm.checkForArrivedShuttle = false;
      if (this.searchForm.status === this.unitArrivedStatus.value) {
        this.searchForm.status = this.unitReceivedStatus.value;
        this.searchForm.checkForArrivedShuttle = true;
      }

      this.search(this.searchForm);
    },
    validateSearch() {
      const canFilterOverOneWeek = this.searchForm.consigneeAccountId || this.searchForm.shipperAccountId || this.searchForm.unitId;

      if (canFilterOverOneWeek) {
        return true;
      }

      const dayOfServiceTo = this.searchForm.dayOfServiceTo ? moment(this.searchForm.dayOfServiceTo.getTime()) : null;
      const untilDate = dayOfServiceTo || moment();

      if (untilDate.diff(this.searchForm.dayOfServiceFrom, 'days') > constants.ONE_WEEK_RANGE) {
        const message = this.$t('outbound.units.filterWarning');
        Message({
          showClose: true,
          message,
          type: 'error',
          duration: constants.MESSAGES.LONG_DURATION
        });
        return false;
      }
      return true;
    }
  },
  mounted() {
    this.handleSearch();
  }
};
</script>
